import { gql } from "apollo-boost";

export const DELETE_PROVIDER = gql`
  mutation DeleteProvider($input: DeleteProviderInput!) {
    deleteProvider(input: $input)
  }
`;
